import { Typography, Button, Container, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import {
  APP_PATH,
  carouselItems,
  DEFAULT_BLUE,
  DEFAULT_BUTTON_STYLE,
  DEFAULT_GOLD,
} from "../../constant";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import PersonIcon from "@mui/icons-material/Person";
import TollIcon from "@mui/icons-material/Toll";
import Carousel from "../../GeneralComponents/Carousel/Carousel";
import Header from "../../GeneralComponents/Header/Header";

const Home = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#f0f0f0", py: 6 }}>
        <Container maxWidth="lg">
          <Box
            display="flex"
            flexDirection={{
              xs: "column",
              md: "row",
            }}
            alignItems="center"
            justifyContent="space-between"
          >
            <Box flex={1} p={2}>
              <Header title="Bienvenue à l'Institut" subtitle="Al-Ansarr" />
              <Typography variant="h6" color="textSecondary" paragraph>
                Le meilleur de l'enseignement en ligne.
                <br />
                Apprenez l'arabe en seulement 2 années chez nous.
              </Typography>
              <Link to={APP_PATH.PROGRAM}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: DEFAULT_BLUE,
                    color: DEFAULT_GOLD,
                    ...DEFAULT_BUTTON_STYLE,
                  }}
                  size="large"
                >
                  Découvrir nos cours
                </Button>
              </Link>
            </Box>

            <Box flex={1} p={2}>
              <Carousel items={carouselItems} height={350} />
            </Box>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 6, backgroundColor: "white" }}>
        <Typography variant="h4" align="center" gutterBottom>
          Pourquoi choisir l'institut Al-Ansarr ?
        </Typography>

        <Box display="flex" flexWrap="wrap" justifyContent="space-around">
          {features.map((feature, index) => (
            <Box
              key={index}
              flexBasis={{ xs: "100%", sm: "45%", md: "30%" }}
              mb={4}
              p={1}
            >
              <Grid container spacing={2}>
                <Grid size={2}>
                  <div>{feature?.icon}</div>
                </Grid>
                <Grid size={10}>
                  <Typography variant="h5" component="div">
                    {feature.title}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      textAlign: "justify",
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      </Container>
    </>
  );
};

const features = [
  {
    title: "Enseignants compétents",
    description:
      "Choisis minutieusement pour vous chacun d'entre eux a suivi avant de nous rejoindre une séléction durant laquelle, la croyance du professeur, son niveau en arabe et sa capacité à transmettre cette science sont vérifiés",
    icon: <PersonIcon fontSize="large" />,
  },
  {
    title: "Programme adapté",
    description:
      "S'étalant sur deux années vous permettant ainsi d'avoir des bases solides avec lesquelles vous pourrez enfin comprendre la parole du Seigneur des mondes, de son prophète, et de nos savants",
    icon: <HistoryEduIcon fontSize="large" />,
  },
  {
    title: "Satisfait ou remboursé",
    description:
      "Aucun doute sur notre enseignement donc chez nous c'est satisfait ou remboursé durant votre premier mois de cours",
    icon: <TollIcon fontSize="large" />,
  },
];

export default Home;
